import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--ink)] text-white">
      <div className="wrap py-24">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-6">
            <img
              src="https://customer-assets.emergentagent.com/job_dave-wraps-studio/artifacts/rzh2dyxf_cropped-928_Logo-281x300.png"
              alt="928 Wraps"
              className="h-12 md:h-14 w-auto mb-8"
              style={{ filter: "invert(1) brightness(2)" }}
            />
            <div className="eyebrow eyebrow-red">Ready when you are</div>
            <h3 className="h-display text-5xl md:text-7xl mt-4 uppercase leading-[0.9]">
              Let&apos;s put every <br/> surface to work.
            </h3>
            <p className="mt-6 text-neutral-400 max-w-md">
              Wraps, window tint, or signage — tell us about your project and get a free, no-pressure quote before you commit to a single dollar.
            </p>
            <Link to="/mockup" data-testid="footer-cta" className="btn-red mt-8">
              Get My FREE Mockup <ArrowRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-neutral-500">Studio</div>
            <div className="mt-4 space-y-3 text-neutral-300">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-[var(--red)]" />
                <span>8920 E Valley Rd<br/>Prescott Valley, AZ 86314</span>
              </div>
              <a href="tel:+19282730784" className="flex items-center gap-3 hover:text-white" data-testid="footer-phone">
                <Phone size={16} className="text-[var(--red)]" /> (928) 273-0784
              </a>
              <a href="mailto:Quotes@928wraps.com" className="flex items-center gap-3 hover:text-white" data-testid="footer-email">
                <Mail size={16} className="text-[var(--red)]" /> Quotes@928wraps.com
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-neutral-500">Explore</div>
            <ul className="mt-4 space-y-2 text-neutral-300">
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
              <li><Link to="/about" className="hover:text-white">About Dave</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/mockup" className="hover:text-white">FREE Mockup</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="eyebrow text-neutral-500">
            © {new Date().getFullYear()} 928 Wraps · Prescott Valley, Arizona
          </div>
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/928wraps/" target="_blank" rel="noopener noreferrer" aria-label="928 Wraps on Instagram" className="text-neutral-500 hover:text-white"><Instagram size={18}/></a>
            <a href="https://www.facebook.com/p/928-Wraps-100063580150655/" target="_blank" rel="noopener noreferrer" aria-label="928 Wraps on Facebook" className="text-neutral-500 hover:text-white"><Facebook size={18}/></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
